import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminGroupEditHeader = ({
  groupId,
}) => {
  const intl = useIntl();

  return (
    <header className="page-header">
      <h3>
        {
          groupId ?
            intl.formatMessage({ defaultMessage: 'Edit Team' }) :
            intl.formatMessage({ defaultMessage: 'New Team' })
          }
      </h3>
    </header>
  );
};

AdminGroupEditHeader.propTypes = {
  groupId: PropTypes.string,
};

AdminGroupEditHeader.defaultProps = {
  groupId: null,
};

export default AdminGroupEditHeader;
